import React from 'react';
import {map, uniqueId} from 'lodash';

import styles from './design-usage-example.module.scss';

interface Props {
  image: React.ReactNode;
  title: string;
  description: string;
  examples: string[];
}

const DesignUsageExample = ({image, title, description, examples}: Props) => (
  <div className={styles.container}>
    <div className={styles.image}>{image}</div>
    <div className={styles.explanation}>
      <p className={styles.title}>{title}</p>
      <p>{description}</p>
      <p className={styles.example}>Examples</p>
      <ul>
        {map(examples, (example) => (
          <li key={uniqueId('design-usage-')}>{example}</li>
        ))}
      </ul>
    </div>
  </div>
);

export default DesignUsageExample;
